import GlobalSnackbar from '@components/Shared/GlobalSnackbar.tsx';
import LoadingOverlay, { LoadingIndicator } from '@components/Shared/LoadingOverlay.tsx';
import { Box, Typography } from '@mui/material';
import { StyledEngineProvider } from '@mui/material/styles';
import { persistor, store } from '@store/store.ts';
import 'line-awesome/dist/line-awesome/css/line-awesome.min.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import App from './App.tsx';
import './extensions';
import './index.css';
import { initializeApp } from './initApp.ts';

const root = createRoot(document.getElementById('root')!);

root.render(
  <Box sx={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    width: '100vw',
    backgroundColor: '#05070A'
  }}>
    <LoadingIndicator />
  </Box>
);

initializeApp()
  .then(_config => {
    root.render(
      <StrictMode>
        <StyledEngineProvider injectFirst>
          <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
              <App />
              <GlobalSnackbar />
              <LoadingOverlay />
            </PersistGate>
          </Provider>
        </StyledEngineProvider>
      </StrictMode>
    );
  })
  .catch(error => {
    root.render(
      <Box sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        width: '100vw',
        whiteSpace: 'pre-line',
        backgroundColor: '#05070A'
      }}>
        <Typography color='white' >
          System cannot initialized. Try to refresh the page after few seconds.
        </Typography>
        {error?.toString() && <Typography color='red' >
          {error.toString()}
        </Typography>}
      </Box>
    );
  });
